"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

import NavBar from "@/app/components/NavBar";
import Footer from "@/app/components/Footer";
import DoctorSelector from "@/app/components/DoctorSelector";
import type IHeaderSchema from "@/app/interfaces/header";

interface MakeAppointmentPageClientProps {
  locale: string;
  headers: IHeaderSchema;
}

type PageMode = "menu" | "appointment";

const t = (key: string, headers: IHeaderSchema): string => {
  return (headers as unknown as Record<string, string>)[key] || key;
};

export default function MakeAppointmentPageClient({ locale, headers }: MakeAppointmentPageClientProps) {
  const router = useRouter();
  const [mode, setMode] = useState<PageMode>("menu");

  const handleBackToMenu = () => {
    setMode("menu");
  };

  const handleAppointmentComplete = (_doctorId: string, _timeSlotId: string, _date: string, _time: string) => {
    router.push(`/${locale}/payment`);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <NavBar locale={locale} />

      <div className="flex-grow relative flex items-center justify-center p-6">
        <div className="w-full max-w-2xl">
          {mode === "menu" && (
            <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
              {/* Umów wizytę */}
              <button
                onClick={() => setMode("appointment")}
                className="flex-1 max-w-xs group hover:opacity-80 transition-opacity"
              >
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 rounded-2xl p-8 text-center h-64 flex flex-col justify-center items-center hover:border-blue-300 transition-colors"
                >
                  <h2 className="text-3xl font-bold text-blue-900 mb-4 group-hover:text-blue-700">
                    {t("makeAppointment", headers)}
                  </h2>
                  <p className="text-blue-700 text-lg">Zarezerwuj wizytę u specjalisty</p>
                </div>
              </button>

              {/* Zapłać */}
              <button
                onClick={() => router.push(`/${locale}/payment`)}
                className="flex-1 max-w-xs group hover:opacity-80 transition-opacity"
              >
                <div className="bg-gradient-to-br from-green-50 to-green-100 border-2 border-green-200 rounded-2xl p-8 text-center h-64 flex flex-col justify-center items-center hover:border-green-300 transition-colors"
                >
                  <h2 className="text-3xl font-bold text-green-900 mb-4 group-hover:text-green-700">
                    {t("pay", headers)}
                  </h2>
                  <p className="text-green-700 text-lg">Dokonaj płatności bez rezerwacji</p>
                </div>
              </button>
            </div>
          )}

          {mode === "appointment" && (
            <div className="space-y-8">
              <DoctorSelector locale={locale} headers={headers} onAppointmentComplete={handleAppointmentComplete} />
            </div>
          )}
        </div>
      </div>

      <Footer locale={locale} />
    </div>
  );
}
